import React from "react";
import GalleryBtnWithModal from "./shared/galleryBtnWithModal";
import { getSourceImageUrlToCGI } from "../utils/base";

const GalleryTeaser = ({
  featVideo,
  gallery,
  containerClass = "grid grid-cols-3 grid-rows-3 gap-3",
  featureImageClass = "h-56 sm:h-80"
}) => {
  return (
    <>
      <div className={containerClass}>
        {gallery?.slice(0, 4).map((galleryItem, idx) => (
          <React.Fragment key={`gitem-${idx}`}>
            {idx === 0 && (
              <div
                key={`gitem-${idx}`}
                className={`${featureImageClass} text-white bg-center bg-no-repeat bg-cover rounded-md sm:col-span-3 sm:row-span-2`}
                style={{
                  backgroundImage: `url(${getSourceImageUrlToCGI({
                    uri: encodeURI(
                      galleryItem?.localFile &&
                        galleryItem?.localFile?.publicURL
                        ? galleryItem?.localFile?.publicURL
                        : galleryItem?.sourceUrl
                    )
                  })})`
                }}
              />
            )}

            {idx > 0 && idx < 3 && (
              <div
                key={`gitem-${idx}`}
                className="h-56 text-white bg-center bg-no-repeat bg-cover rounded-md md:h-full"
                style={{
                  backgroundImage: `url(${getSourceImageUrlToCGI({
                    uri: encodeURI(
                      galleryItem?.localFile &&
                        galleryItem?.localFile?.publicURL
                        ? galleryItem?.localFile?.publicURL
                        : galleryItem?.sourceUrl
                    )
                  })})`
                }}
              />
            )}

            {idx === 3 && (
              <div
                key={`gitem-${idx}`}
                className="relative h-56 bg-center bg-no-repeat bg-cover rounded-md md:h-full"
                style={{
                  backgroundImage: `url(${getSourceImageUrlToCGI({
                    uri: encodeURI(
                      galleryItem?.localFile &&
                        galleryItem?.localFile?.publicURL
                        ? galleryItem?.localFile?.publicURL
                        : galleryItem?.sourceUrl
                    )
                  })})`
                }}
              >
                <div className="absolute w-full program-gallery-more -bottom-14 md:bottom-3">
                  <GalleryBtnWithModal
                    featVideo={featVideo}
                    galleryPhotos={gallery}
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default GalleryTeaser;
